import React, { useState, useEffect } from "react";
import SimpleQuestionComponent from "./SimpleQuestionComponent";
import IconQuestionComponent from "./IconQuestionComponent";
import EmailComponent from "./EmailComponent";
import TextComponent from "./TextComponent";
import Firebase from "../../../../../assets/Firebase";

const QuestionEngine = ({ index, config, question, actions, screen }) => {
    const f = new Firebase();
    let animationPlaying = false;

    const [activate, setActivate] = useState(false);

    const Wrapper = {
        display: "flex",
        justifyContent: "center",
        width: "calc(100% - 4vh)",
        margin: "2vh",
        flex: "1"
    };

    const isMultipleOptionAllowed = () => {
        return (question?.type == "MULTIOPTION");
    }

    const isMonoOptionAllowed = () => {
        return (question?.type == "MONOOPTION");
    }

    const isDobleQuestionAllowed = () => {
        return (screen?.type == "DOUBLE");
    }

    const isSatisfactionOptionAllowed = () => {
        return (question?.type == "SATISFACTION");
    }

    const isSatisfactionExtendedAllowed = () => {
        return (question?.type == "SATISFACTION_EXTENDED");
    }

    const isTextAllowed = () => {
        return (question?.type == "FREE_TEXT");
    }

    const isNPSAllowed = () => {
        return (question?.type == "NPS");
    }

    const isYNAllowed = () => {
        return (question?.type == "YES_NO");
    }

    const isSecondQuestion = () => {
        return (question?.order == 1);
    }

    const isFinalScreen = () => {
        return (screen?.order == config.surveys.screens.lenght);
    }

    const selectOption = (optionIndex) => {
        if (!animationPlaying) {
            animationPlaying = true;

            let options = question?.options;
            let selectedOption = options?.[optionIndex];
            let multipleOption = isMultipleOptionAllowed();
            let dobleQuestion = isDobleQuestionAllowed();

            if (multipleOption) {
                if(selectedOption.suboptions.length === 0){
                    selectedOption.selected = !selectedOption.selected;
                }else{
                    selectedOption.selected = true;
                }
            } else {
                options.forEach(op => op.selected = false);
                selectedOption.selected = true;
            }

            actions.updateQuestion(index, "options", options);

            if (!(multipleOption || dobleQuestion)) {
                timeForward(1100);
            }
            if (isSecondQuestion() && (!multipleOption || isFinalScreen()) && !(screen.questions[0].options[0].selected === undefined)) {
                timeForward(1100);
            }
            if (!isSecondQuestion() && isDobleQuestionAllowed() && (!multipleOption || isFinalScreen()) && !(screen.questions[1].options[0].selected === undefined)) {
                timeForward(1100);
            }
        }
    }

    const selectSubOption = (optionIndex, suboptionIndex) => {
        let multipleOption = isMultipleOptionAllowed();
        let options = question?.options;
        let suboptions = options[optionIndex]?.suboptions;
        let selectedSubOption = suboptions?.[suboptionIndex];

        //Comprobación/Modificación de sí ya estaba seleccionado o no dependiendo del tipo de question y actualización
        if (selectedSubOption.selected === true) {
            selectedSubOption.selected = false;
        }
        else {
            if (!multipleOption) {
                options.forEach(op => {
                    op.selected = false;
                    op.suboptions.forEach(subop => {
                        subop.selected = false
                    });
                });
            }
            else {
                options.forEach(op => {
                    if(op.suboptions == suboptions){
                        op.suboptions.forEach(subop => {
                            subop.selected = false
                        });
                    }
                });
            }
            selectedSubOption.selected = true;
        }

        actions.updateQuestion(index, "options", options);

        //Dependiendo de si tiene o no algún suboption seleccionado, des selecciona la opción principal o salta a la siguiente question
        let unSelect = false;
        suboptions.forEach(op => {
            if (op.selected === true) {
                unSelect = true;
            }
        });

        if (unSelect) {
            selectOption(optionIndex);
        }
        else {
            let selectedOption = options?.[optionIndex];
            selectedOption.selected = false;
            actions.updateQuestion(index, "options", options);
        }

    }

    const addFreeTextResponse = (key, value) => {
        let freeResponse = question?.freeResponse || {};
        freeResponse[key] = value;
        actions.updateQuestion(index, "freeResponse", freeResponse);
        isActivate();
    }

    const timeForward = (time) => {
        setTimeout(() => {
            isActivate()
            actions.goForward()
            animationPlaying = false;
        }, time);
    }

    const isAnySelectedOption = () => {
        let options = question?.options;
        return options.some((op) => op?.selected);
    }

    const acceptButton = () => {
        timeForward(0);
    }

    const isActivate = () => {
        let freeResponse = question?.freeResponse || null;
        if (freeResponse !== null) {
            if ((freeResponse?.name !== "") && (freeResponse?.email !== "") && freeResponse?.checkedLOPD) setActivate(true)
            else if (freeResponse?.freeText !== "" && isTextAllowed()) setActivate(true)
            else setActivate(false)
        }
        else setActivate(false)
    }

    const openRGPD = () => {
        config.popupLoading("Loading RGPD");
        f.getRGPD(config.uid, (data) => {
            config.closePopupLoading();
            if (data?.content) {
                config.popupAlert(config?.strings?.RGPD, data?.content, null, false, null, null, null, true);
            }
        }, (error) => {
            config.closePopupLoading();
            console.error("Error loading RGPD", error);
        });
    }

    const cardOption = (num) => {
        let options = question?.options;
        return options[num]?.cardOption;
    } 

    const childActions = {
        ...actions,
        selectOption: selectOption,
        selectSubOption: selectSubOption,
        addFreeTextResponse: addFreeTextResponse,
        openRGPD: openRGPD,
        isAnySelectedOption: isAnySelectedOption,
        acceptButton: acceptButton,
        timeForward: timeForward,
        cardOption: cardOption,
        isSatisfactionOptionAllowed: isSatisfactionOptionAllowed,
        isSatisfactionExtendedAllowed: isSatisfactionExtendedAllowed,
        isMultipleOptionAllowed: isMultipleOptionAllowed,
        isNPSAllowed: isNPSAllowed,
        isYNAllowed: isYNAllowed,
    }

    const renderQuestionByType = () => {
        actions.isEmailQuestion();
        switch (question?.type) {
            case "MONOOPTION":
            case "MULTIOPTION":
                return (<SimpleQuestionComponent config={config} question={question} actions={childActions} />);
            case "ICON_OPTIONS":
            case "SATISFACTION":
            case "SATISFACTION_EXTENDED":
            case "YES_NO":
            case "NPS":
                return (<IconQuestionComponent config={config} question={question} actions={childActions} />);
            case "EMAIL":
                return (<EmailComponent config={config} question={question} actions={childActions} activate={activate} />);
            case "FREE_TEXT":
                return (<TextComponent config={config} question={question} actions={childActions} activate={activate} />);
            default:
                return (<div>Type not handled</div>);
        }
    }

    useEffect(() => {
        isActivate();
    }, [isTextAllowed])

    return (
        <div style={Wrapper}>
            {renderQuestionByType()}
        </div>
    );
};

export default QuestionEngine;
